import React from 'react';
import { surpassInLoaderGIF } from '../../assets';

function Spin() {
  return (
    <div className=" h-full w-full">
      <div className="flex justify-center items-center text-center w-full h-full">
        <img src={surpassInLoaderGIF} className="w-[250px]" />
      </div>
    </div>
  );
}

export default Spin;
